type AdminUnauthorizedHandler = () => void;

let handler: AdminUnauthorizedHandler | undefined;

const setAdminUnauthorizedHandler = (next?: AdminUnauthorizedHandler): void => {
  handler = next;
};

const notifyAdminUnauthorized = (): void => {
  handler?.();
};

export { notifyAdminUnauthorized, setAdminUnauthorizedHandler };
export type { AdminUnauthorizedHandler };
